import spinner from "../../assets/icons/spinner.svg";

const PortalQuoteSettingStatus = () => (
    <span className="portal-quote-setting-status" role="status">
        <img src={spinner} alt="" />
        Saving…
    </span>
);

export default PortalQuoteSettingStatus;
